// based on rc-checkbox 2.1.7
export { default } from './src/';


//////////////////
// WEBPACK FOOTER
// ./~/ant-design-vue/es/vc-checkbox/index.js
// module id = 347
// module chunks = 0